import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

// prettier-ignore
function MarketId({ pair, isActive, isHeading, iconSize, noIcon, styles: customStyles }) {
  const assets = pair.includes('-')
    ? pair.split('-')
    : pair.split('/');


  return (
    <div className={classnames([styles.marketId], ...customStyles)}>
      {!noIcon && (
        <span className={classnames([styles.assetMargin])}>
          <nbx-asset-icon 
            asset={assets[0]} 
            size={iconSize}  
          />
        </span>
      )}
      <Text
        tag={isHeading ? 'h3' : 'span'}
        styles={[
          {
            [styles.textMarketId]: !isHeading,
            [styles.headingMarketId]: isHeading,
            [styles.active]: isActive
          }
        ]}
      >
        <Text styles={[{[styles.active]: isActive}]}>{assets[0]}</Text>
        {assets[1] && (
          <Text styles={[{[styles.active]: isActive}]} muted={!isActive}>&nbsp;/ {assets[1]}</Text>
        )}
      </Text>
    </div>
  );
}

MarketId.propTypes = {
  pair: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isHeading: PropTypes.bool,
  iconSize: PropTypes.string,
  noIcon: PropTypes.bool,
  styles: PropTypes.array
};

MarketId.defaultProps = {
  isActive: false,
  isHeading: false,
  iconSize: '32',
  noIcon: false,
  styles: []
};

export default MarketId;
